import { RouteObject } from 'react-router-dom'

import SignIn from '../pages/SignIn'
import SignUp from '../pages/SignUp'

// Note: Landing page route ('/') is handled separately in AppRoutes
// to allow authenticated users to see Home instead of Landing
const guestRoutes: RouteObject[] = [
  { path: '/sign-up', element: <SignUp /> },
  { path: '/sign-in', element: <SignIn /> },
]

export default guestRoutes
